import { UserAttachment, type AttachmentRow } from "./UserAttachment";

// Attachments on a sent user message: a wrapped image grid above a wrapped file
// grid, so a large batch reads as two blocks instead of one tall column.
//
// A kind is only known once the preview resolves, so both rows are offered every
// id and each attachment renders in exactly one of them. The duplicate mount
// costs no extra request — the by-id preview is SWR-cached on its URL — and an
// empty row collapses via `empty:hidden`.
export const UserAttachments = ({ ids }: { ids: string[] }) => (
  <>
    <AttachmentGrid ids={ids} row="images" />
    <AttachmentGrid ids={ids} row="files" />
  </>
);

const AttachmentGrid = ({ ids, row }: { ids: string[]; row: AttachmentRow }) => (
  <div
    data-testid={`attachment-row-${row}`}
    className="flex w-full flex-wrap justify-end gap-2 empty:hidden"
  >
    {ids.map((id) => (
      <UserAttachment key={id} id={id} row={row} />
    ))}
  </div>
);
